import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/components/AppShell";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Assistants from "@/pages/Assistants";
import AssistantEditor from "@/pages/AssistantEditor";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Playground from "@/pages/Playground";
import Conversations from "@/pages/Conversations";
import WhatsAppChannel from "@/pages/WhatsAppChannel";

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="font-heading text-4xl font-semibold">404</div>
      <p className="mt-2 text-sm text-muted-foreground">Esta página não existe.</p>
      <Link to="/" className="mt-4 text-sm text-primary underline underline-offset-4">
        Voltar ao dashboard
      </Link>
    </div>
  );
}

/** Enquanto a sessão é validada, nem o console nem o login aparecem — evita o
 *  flash da tela de login a cada recarga de quem já está autenticado. */
function Rotas() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/assistentes" element={<Assistants />} />
        <Route path="/assistentes/novo" element={<AssistantEditor />} />
        <Route path="/assistentes/:id" element={<AssistantEditor />} />
        <Route path="/conhecimento" element={<KnowledgeBase />} />
        <Route path="/playground" element={<Playground />} />
        <Route path="/conversas" element={<Conversations />} />
        <Route path="/whatsapp" element={<WhatsAppChannel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Rotas />
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
